import { render } from "./Sitemap.vue?vue&type=template&id=47e4918a&ts=true"
import script from "./Sitemap.vue?vue&type=script&lang=ts"
export * from "./Sitemap.vue?vue&type=script&lang=ts"

import "./Sitemap.vue?vue&type=style&index=0&id=47e4918a&lang=scss"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__